import { PayCheck, PayCheckFile } from '@/interfaces/paycheck';
import { PaginatedResponse } from '@/interfaces/response';
import { Note } from '@/interfaces/note';
import { AxiosPromise } from 'axios';
import request from '@/umi-request';


export async function uploadPaycheck(affiliate: number, data: any) {
  return request({
    url: `affiliates/${affiliate}/paychecks/`,
    method: 'POST',
    data: { data }
  }) as AxiosPromise<PayCheck>;
}

export async function uploadFile(affiliate: number, data: any) {
  return request({
    url: `affiliates/${affiliate}/paychecks/upload-file/`,
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: { data }
  }) as AxiosPromise<PayCheckFile>;
}

export async function cancelPaycheck(affiliate: number, id: number) {
  return request({
    url: `affiliates/${affiliate}/paychecks/${id}/cancel/`,
    method: 'POST',
  }) as AxiosPromise<PayCheck>;
}

export async function updatePaycheck(affiliate: number, id: number, data: any) {
  return request({
    url: `affiliates/${affiliate}/paychecks/${id}/update/`,
    method: 'PATCH',
    data: { ...data }
  }) as AxiosPromise<PayCheck>;
}

export async function queryPaychecks(params: any) {
  return request({
    url: `paychecks/`,
    method: 'GET',
    params
  }) as AxiosPromise<PaginatedResponse<PayCheck>>;
}

export async function queryPaycheck(id: number | string) {
  return request({
    url: `paychecks/${id}/`,
    method: 'GET',
  }) as AxiosPromise<PayCheck>;
}

export async function updatePaycheckStatus(id: number | string, data: any) {
  return request({
    url: `paychecks/${id}/`,
    method: 'PATCH',
    data
  }) as AxiosPromise<PayCheck>;
}

export async function queryPaychecksChangesHistory(id: number | string) {
  return request({
    url: `paychecks/${id}/changes-history/`,
    method: 'GET'
  }) as AxiosPromise<PayCheck[]>;
}

export async function queryPaycheckHistory(id: number | string) {
  return request({
    url: `paychecks/${id}/history/`,
    method: 'GET',
  }) as AxiosPromise<PayCheck[]>;
}

export async function sendPaycheckNote(id: number | string, data: { content: string }) {
  return request({
    url: `paychecks/${id}/notes/`,
    method: 'POST',
    data
  }) as AxiosPromise<Note<PayCheck>>;
}

export async function getPaycheckNotes(id: number | string) {
  return request({
    url: `paychecks/${id}/notes/`,
    method: 'GET',
  }) as AxiosPromise<Note<PayCheck>[]>;
}
